import { lighten, transparentize, linearGradient } from "polished";

export const background = linearGradient({
    colorStops: ['#0E0620 0%', '#3A18A5 60%', '#8A5DD9 90%'],
    toDirection: 'to bottom',
    fallback: '#000',
    });

export const base = "#110A26";
export const baseLightBefore = lighten(0.04, base);
export const baseLight = transparentize(0, baseLightBefore);
// export const baseLighter = lighten(0.4, base);
export const baseLighter = linearGradient({
    colorStops: ['#0E0620 0%', '#3A18A5 60%', '#8A5DD9 90%'],
    toDirection: 'to left top',
    fallback: '#000',
    });

export const content = "#DDDDDD";
// export const contentDark = transparentize(0.5, content);

export const halo = lighten(0.01, base);
export const hover = "#72EEFF";
export const hoverAlt = transparentize(0.83, hover);